export default {
  namespaced: true,
  employees_units: {
    title: 'Asigación de empleos | Asignación de empleo',
    schedules: 'Horarios',
    monday: 'Lunes',
    tuesday: 'Martes',
    wednesday: 'Miércoles',
    thursday: 'Jueves',
    friday: 'Viernes',
    saturday: 'Sábado',
    sunday: 'Domingo',
    start: 'Entrada',
    end: 'Salida',
    startInvalid: 'Entrada invalida',
    endInvalid: 'Salida invalida'
  }
}
